module.exports = __webpack_public_path__ + "static/hsj-2726edd31d5e38738aef549ea870a304.png";